<template><CatalogManager type="subspecialties" title="Subespecialidades" /></template>
<script>import CatalogManager from '../components/catalog-manager.vue'; export default { components:{ CatalogManager } };</script>
